/**
 * Детерминированный генератор: одинаковый сид даёт одинаковый мир.
 * Нужен для отладки багов по репорту — тестер присылает сейв, мир воспроизводится один в один.
 */

export interface Rng {
  /** [0, 1) */
  next(): number;
  /** Целое в [min, max] включительно. */
  int(min: number, max: number): number;
  /** Случайный элемент; для пустого массива — undefined. */
  pick<T>(items: readonly T[]): T | undefined;
  /** true с вероятностью p. */
  chance(p: number): boolean;
}

/** Строковый сид → 32-битное зерно. */
function hashSeed(seed: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < seed.length; i++) {
    h ^= seed.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function createRng(seed: string | number): Rng {
  let state = (typeof seed === 'number' ? seed >>> 0 : hashSeed(seed)) || 1;

  const next = (): number => {
    // mulberry32
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };

  return {
    next,
    int: (min, max) => min + Math.floor(next() * (max - min + 1)),
    pick: (items) => (items.length === 0 ? undefined : items[Math.floor(next() * items.length)]),
    chance: (p) => next() < p,
  };
}

/**
 * Именованный поток от общего сида: мир, патрули и броски не должны
 * тянуть числа из одного источника, иначе один лишний бросок сдвигает всё.
 */
export function streamRng(seed: string, stream: string, day = 0): Rng {
  return createRng(`${seed}:${stream}:${day}`);
}
